import React from 'react';
import { Route } from 'react-router';

import Login from './login';
import Finish from './finish';
import Forgot from './forgot';

import '../../css/main.css';

export default () =>
  <div>
    <Route path="/auth/login" component={Login} />

    <Route path="/auth/finish/:code/:email" component={Finish} />

    <Route path="/auth/forgot" component={Forgot} />
  </div>;



// WEBPACK FOOTER //
// ./src/views/auth/index.js